<template>
  <div class="randomizer-card" ref="cardRoot">
    <div
      :class="[
        'randomizer-card_scene',
        { 'randomizer-card_scene__flipped' : isCardFlippeed },
      ]"
      ref="randomizerCard"
    >
      <div
        class="randomizer-card_body"
        @click="cardFlip"
      >
        <div class="randomizer-card_body-face">
          <img class="randomizer-card_game-back" :src="gameImgUrl" />
        </div>
        <div class="randomizer-card_body-back">
          <template v-if="status === DATA_STATUS.NEED_AUTH">
            <a :href="redirectUrl" class="randomizer-card_link-full-size red_link">{{ $c('Авторизуйтесь') }}</a>
          </template>
          <template v-if="status === DATA_STATUS.NEED_PARTICIPATE">
            <a @click="$root.$emit('randomRewardsBindCard')" class="randomizer-card_link-full-size red_link">{{ $c('Для старта привяжи свою карту') }}</a>
          </template>
          <template v-if="status === DATA_STATUS.DATA_READY">
            <Transition name="card-transition" mode="out-in" appear>
              <template v-if="!isCardFlippeed">
                <template v-if="randomButtonData.status === RANDOM_BUTTON_STATUS.FINISH">
                  <p v-if="spinBalance" class="red_link">{{ $c('Крути карту!') }}</p>
                  <p v-else
                     v-html="$c('Доступных Шансов больше нет!%(br)s Спасибо за участие в акции!', {br: '<br />'})"
                  />
                </template>
                <template v-else>
                  <p v-if="spinBalance" class="red_link">{{ $c('Крути карту!') }}</p>
                  <template v-else>
                    <p v-if="spinsTotal" class="spin_balance_0"
                       v-html="$c('Выполняй задания,%(br)s чтобы получить Шансы!', {br : '<br>'})"
                    />
                    <p v-else
                       v-html="$c('Выполни стартовое задание')"
                    />
                  </template>
                </template>
              </template>
              <template v-else>
                <div class="randomizer-card_body-back">
                  <Transition name="card-transition" mode="out-in" appear>
                    <img
                      class="randomizer-card_benefit"
                      v-bind:key="cardImage"
                      :src="cardImage"
                    />
                  </Transition>
                  <Transition name="card-transition" mode="out-in" appear>
                    <p
                      v-bind:key="cardText"
                      class="randomizer-card_benefit-description"
                    >
                      <span v-if="cardImage && cardText">{{$c('Подарок — ')}}</span>
                      <span>{{ cardText }}</span>
                    </p>
                  </Transition>
                </div>
              </template>
            </Transition>
          </template>
        </div>
      </div>
      <svg
        width="554"
        height="24"
        viewBox="0 0 554 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="randomizer-card_shadow"
      >
        <ellipse opacity="0.24" cx="277" cy="12" rx="277" ry="12" fill="url(#paint0_radial)"/>
        <defs>
          <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(277 12) rotate(90) scale(12 277)">
            <stop/>
            <stop offset="1" stop-opacity="0"/>
          </radialGradient>
        </defs>
      </svg>
    </div>
    <div  v-if="status === DATA_STATUS.DATA_READY" class="randomizer-card_spins-left">
      <div class="randomizer-card_spins-left_text">
        <span>{{ $c('Доступно Шансов:') }}</span>
        <span :class="['task_spins', {'task_spins__grey': !spinBalance}]">
          <span class="task_spins-45deg">{{ spinBalance }}</span>
        </span>
        <div class="randomizer-card_history-link">
          <span class="tab-desktop-text">
            {{ $c('История начисления бонусов') }}
            <RouterLink
              class="red_link"
              :to="`/cards/${cardCode || ''}`"
            >
              {{ $c('здесь') }}
            </RouterLink>
          </span>
          <span class="mobile-text">
            {{ $c('Твои бонусы') }}
            <RouterLink
              class="red_link"
              :to="`/cards/${cardCode || ''}`"
            >
              {{ $c('здесь') }}
            </RouterLink>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import { RANDOM_REWARDS_DATA_STATUS as DATA_STATUS, RANDOM_BUTTON_STATUS } from '@/constants'
import { getAuthenticationActionUrl, isMobile } from '@/helpers'
import { namespace, State } from 'vuex-class'

const randomRewards = namespace('randomRewards')

@Component({
  components: {}
})
class Card extends Vue {
  @Prop({
    type: String,
    required: true
  }) status

  @randomRewards.State('spinBalance') spinBalance
  @randomRewards.State('spinsTotal') spinsTotal
  @randomRewards.State('cardImage') cardImage
  @randomRewards.State('cardText') cardText
  @randomRewards.State('cardCode') cardCode
  @randomRewards.Action('play') play
  @randomRewards.Action('resetCardImage') resetCardImage
  @State('randomButtonData') randomButtonData

  RANDOM_BUTTON_STATUS = RANDOM_BUTTON_STATUS
  DATA_STATUS = DATA_STATUS

  isCardFlippeed = false
  redirectUrl = getAuthenticationActionUrl('signin')

  get gameImgUrl () {
    return require('@/components/GameSwitcher/img/' + this.randomButtonData.game + '.svg')
  }
  get gameBenefitUrl () {
    return `/img/benefits/mt-prem.png`
  }

  mounted () {
    const card = this.$refs.randomizerCard
    const cardRoot = this.$refs.cardRoot
    this.onCardAnimationEnd = this.onCardAnimationEnd.bind(this)
    card.addEventListener('animationend', this.onCardAnimationEnd)
    let y = 0; let x = 0; let endX = 0; let endY = 0
    const maxDegX = 20
    const maxDegY = -20
    function parallax () {
      x += (endX - x) / 2
      y += (endY - y) / 2

      cardRoot.style.transform = `
        rotateY(${(x / (innerWidth / 2)) * maxDegX}deg)
        rotateX(${(y / (innerHeight / 2)) * maxDegY}deg)
        perspective(${innerWidth * 2 - x}px)
      `

      requestAnimationFrame(parallax)
    }

    if (!isMobile()) {
      requestAnimationFrame(parallax)
      window.onmousemove = (e) => {
        endX = innerWidth / 2 - e.x
        endY = innerHeight / 2 - e.y
      }
    }
  }

  onCardAnimationEnd () {
    this.isCardFlippeed = false
  }

  cardFlip () {
    if (this.status !== DATA_STATUS.DATA_READY || !this.spinBalance || this.isCardFlippeed) return
    this.resetCardImage()
    this.play()
    this.isCardFlippeed = true
  }
}

export default Card
</script>

<style lang="scss">
  %face-back {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 84vw;
    height: 60vw;
    border-radius: 20px;
    text-align: center;
    @include media_tablet {
      width: 320px;
      height: 200px;
    }
    @include media_desktop {
      width: 520px;
      height: 330px;
    }
  }
  .randomizer-card {
    position: relative;
    &_scene {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 100%;
      min-height: 100vw;
      @include media_tablet {
        min-height: 385px;
      }
      @include media_desktop {
        min-width: 600px;
        min-height: 600px;
      }
      transform-style: preserve-3d;
      &__flipped {
        animation: cardFlip 8s forwards cubic-bezier(0.02, 0.62, 0.56, 0.96);
      }
    }
    &_body {
      @extend %face-back;
      background: #000D1C;
      box-shadow: 0px 0px 80px rgba(225, 5, 20, 0.5), inset 0px 1px 0px rgba(225, 5, 20, 0.7);
      border-radius: 20px;
      transform: rotate(-45deg);
      position: relative;
      transform-style: preserve-3d;
    }
    &_body-face {
      @extend %face-back;
      background: #000D1C;
      position: absolute;
      transform: rotateY(180deg);
      backface-visibility: hidden;
    }
    &_body-back {
      @extend %face-back;
      z-index: 4;
      background: #000D1C;
      backface-visibility: hidden;
      .randomizer-card_game {
        z-index: 5;
      }
    }
    &_game {
      position: absolute;
      height: 14px;
      left: 18px;
      top: 18px;
      @include media_desktop {
        left: 40px;
        top: 40px;
        height: auto;
      }
    }
    &_game-back {
      //position: absolute;
      //height: 24px;
      //right: 40px;
      //top: 40px;
      transform: scale(1.2)/* rotateY(180deg)*/;
      @include media_desktop {
        transform: scale(2)
      }
    }
    &_benefit {
      height: calc(100% - 130px);
      max-width: 80%;
    }
    &_benefit-description {
      position: absolute;
      bottom: 40px;
    }
    .spin_balance_0 {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 23px;
      text-align: center;
      color: #FFFFFF;
    }
    p.red_link {
      max-width: 80%;
    }
    .red_link {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #DF002C;
      text-decoration: none;
      cursor: pointer;
      @include media_tablet {
        font-size: 16px;
        line-height: 18px;
      }
      @include media_desktop {
        font-size: 20px;
        line-height: 23px;
      }
      &:hover {
        text-decoration: underline;
      }
    }
    &_shadow {
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
    }
    &_spins-left {
      @extend %face-back;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
      align-items: flex-end;
      pointer-events: none;
      &_text {
        margin-bottom: -40px;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        text-align: right;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        @include media_desktop {
          font-size: 16px;
          line-height: 19px;
          margin-bottom: -80px;
        }
        .task_spins {
          display: block;
          width: 23px;
          height: 15px;
          line-height: 15px;
          background: #CC0022;
          text-align: center;
          vertical-align: middle;
          color: #000000;
          font-style: normal;
          font-weight: bold;
          font-size: 12px;
          margin-left: 5px;
          border-radius: 3px;
          &__grey {
            background-color: #666666;
          }
          @include media_desktop {
            font-size: 16px;
            width: 48px;
            height: 30px;
            line-height: 30px;
            margin-left: 10px;
          }
          &-45deg {
            transform: rotate(45deg);
            display: block;
          }
        }
      }
    }
    &_history-link {
      pointer-events: all;
      display: block;
      white-space: nowrap;
      position: absolute;
      margin-bottom: -60px;
      .red_link {
        font-size: inherit;
      }
      @include media_desktop {
        margin-bottom: -100px;
      }
      > a {
        color: #FF002A;
      }
    }
    .mobile-text {
      display: block;
      @include media_tablet {
        display: none;
      }
    }
    .tab-desktop-text {
      display: none;
      @include media_tablet {
        display: block;
      }
    }
  }
  .randomizer-card_link-full-size {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @keyframes cardFlip {
    0% {
      transform: rotateZ(0deg) rotateY(2080deg);
    }
    30% {
      transform: rotateZ(0deg) rotateY(45deg);
    }
    100% {
      transform: rotateZ(0deg) rotateY(0deg);
    }
  }

.card-transition {
  &-enter-active, &-leave-active {
    transition: all .3s ease-in-out;
  }

  &-enter, &-leave-to {
    transform: translateZ(50px);
    opacity: 0;
  }
}
</style>
